<template>
  <div class="game">
    <div id="score"> </div>
    <div id="buttons">
      <svg height=250 width=350>
        <rect data-note="c" v-on:click='svgClick'/>
        <rect data-note="d" x=50 v-on:click='svgClick'/>
        <rect data-note="e" x=100 v-on:click='svgClick'/>
        <rect data-note="f" x=150 v-on:click='svgClick'/>
        <rect data-note="g" x=200 v-on:click='svgClick'/>
        <rect data-note="a" x=250 v-on:click='svgClick'/>
        <rect data-note="b" x=300 v-on:click='svgClick'/>

        <rect class="black" data-note="c#" x=37 v-on:click='svgClick'/>
        <rect class="black" data-note="d#" x=87 v-on:click='svgClick'/>
        <rect class="black" data-note="f#" x=187 v-on:click='svgClick'/>
        <rect class="black" data-note="g#" x=237 v-on:click='svgClick'/>
        <rect class="black" data-note="a#" x=287 v-on:click='svgClick'/>
      </svg>
    </div>
  </div>
</template>

<script>
import Vex from 'vexflow';
export default {
  name: "About",
  data: function () {
    return {
      tNotes: [],
      bNotes: [],
      // Stores an array of notes in the foramt [note letter, is treble note] used for colouring notes on click
      allNotes: [],
      progress: 0
    }
  },
  methods: {
    svgClick(e) {
      // Use the bool in allNotes to work out if we should grab the note from treble notes or bass
      const currentNote = this.allNotes[this.progress][1] ? this.tNotes[this.progress] : this.bNotes[this.progress]
      if(e.target.dataset.note == this.allNotes[this.progress][0]) {
        currentNote.setStyle({fillStyle: "green", strokeStyle: "green"});
        this.progress = this.progress + 1
      } else {
        currentNote.setStyle({fillStyle: "red", strokeStyle: "red"});
      }

      if(this.progress == 4) {
        this.init()
      } else {
        this.renderSheet()
      }
    },
    init() {
      this.notes = [];
      this.progress = 0;
      this.generateRandomMusic()
      this.renderSheet()
    },
    generateRandomMusic() {
      const VF = Vex.Flow;
      const allNotes = ['a','b','c','d','e','f','g']
      let newTNotes = []
      let newBNotes = []
      let newNoteNames = []
      for(let i = 0; i < 4; i++) {
        const octave = (Math.floor(Math.random() * 4) + 2);
        const randomNote = allNotes[Math.floor(Math.random() * allNotes.length)];
        newNoteNames.push([randomNote, octave > 3])
        if (octave > 3) {
          newTNotes.push(
            new VF.StaveNote({clef: "treble", keys: [randomNote + '/' + octave], duration: "q" })
          )
          newBNotes.push(
            new VF.StaveNote({clef: "bass", keys: ['e/3'], duration: "qr" })
          )
        } else {
          newTNotes.push(
            new VF.StaveNote({clef: "treble", keys: ['c/5'], duration: "qr" })
          )
          newBNotes.push(
            new VF.StaveNote({clef: "bass", keys: [randomNote + '/' + octave], duration: "q" })
          )
        }

      }

      this.tNotes = newTNotes
      this.bNotes = newBNotes
      this.allNotes = newNoteNames
    },
    renderSheet() {
      const VF = Vex.Flow;

      // Create an SVG renderer and attach it to the DIV element named "boo".
      var div = document.getElementById("score")
      div.innerHTML = ''
      var renderer = new VF.Renderer(div, VF.Renderer.Backends.SVG);

      // Size our SVG:
      renderer.resize(440, 300);

      // And get a drawing context:
      var context = renderer.getContext();

      // Create a stave at position 10, 40 of width 400 on the canvas.
      var stave = new VF.Stave(20, 40, 400);

      // Create a stave at position 10, 40 of width 400 on the canvas.
      var stave2 = new VF.Stave(20, 140, 400);
      
      new VF.StaveConnector(stave, stave2)
          .setType('single')
          .setContext(context)
          .draw();

      new VF.StaveConnector(stave, stave2)
          .setType('brace')
          .setContext(context)
          .draw();

      // Add a clef and time signature.
      stave.addClef("treble").addTimeSignature("4/4");
      // Connect it to the rendering context and draw!
      stave.setContext(context).draw();

      // Add a clef and time signature.
      stave2.addClef("bass").addTimeSignature("4/4");
      // Connect it to the rendering context and draw!
      stave2.setContext(context).draw();



      // Create a voice in 4/4 and add the notes from above
      var voice = new VF.Voice({num_beats: 4,  beat_value: 4});
      voice.addTickables(this.tNotes);
      // Format and justify the notes to 400 pixels.
      new VF.Formatter().joinVoices([voice]).format([voice], 400);
      // Render voice
      voice.draw(context, stave);

      // Create a voice in 4/4 and add the notes from above
      var voice2 = new VF.Voice({num_beats: 4,  beat_value: 4});
      voice2.addTickables(this.bNotes);
      // Format and justify the notes to 400 pixels.
      new VF.Formatter().joinVoices([voice2]).format([voice2], 400);
      // Render voice
      voice2.draw(context, stave2);
    }
  },
  mounted(){
    this.init()
  }
};
</script>

<style lang="scss" scoped>
  #buttons {
    display: flex;
    justify-content: center;
    div {
      background-color: #eee;
      padding: 10px;
      margin: 10px
    }
  }

  rect {
    fill: #fff;
    stroke: #000;
    width: 50px;
    height: 200px;
  }

  rect.black {
    fill: #000;
    width: 26px;
    height: 120px;
    z-index: 20;
  }
</style>